import * as React from 'react'

export const useViewport = (): [number | undefined, number | undefined] => {
  const [width, setWidth] = React.useState<number | undefined>(undefined)
  const [height, setHeight] = React.useState<number | undefined>(undefined)

  React.useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return React.useMemo(() => [width, height], [width, height])
}
